import { apiClient } from "./authService";

export const manageSlots = async (slotData: any): Promise<any> => {
  try {
    const response = await apiClient.post("/slots/block", slotData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSlots = async (slotData: any): Promise<any> => {
  try {
    const response = await apiClient.get(`/slots/history/${slotData.business_id}`, { params: slotData });
    return response.data;
  } catch (error) {
    throw error;
  }
};
